// extracted by mini-css-extract-plugin
export default {"text":"VerifyDetails__text--2BJ","btnWrap":"VerifyDetails__btnWrap---R8","btn":"VerifyDetails__btn--2eQ"};